export enum MarginEnum {
  default_margin = 'default_margin',
  without_margin = 'without_margin'
}
